import { render, staticRenderFns } from "./OtherAccountPayableSummary.vue?vue&type=template&id=0b1fc334&scoped=true"
import script from "./OtherAccountPayableSummary.vue?vue&type=script&lang=js"
export * from "./OtherAccountPayableSummary.vue?vue&type=script&lang=js"
import style0 from "./OtherAccountPayableSummary.vue?vue&type=style&index=0&id=0b1fc334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1fc334",
  null
  
)

export default component.exports